// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"3ca3d318","38":"55524643","469":"fdf98af8","536":"2e28d8d6","709":"321fdc6d"}[chunkId] + ".chunk.css";
};